import { ReactNode } from "react";
import Link, { LinkProps } from "next/link";
import { Link as MuiLink, LinkProps as MuiLinkProps } from "@mui/material";
import { prependLocaleToPath, useLocale } from "../../../helpers/locale";
import { useHrefKeepingRedirectionParams } from "../../../helpers/navigation";

interface Props extends Pick<LinkProps, "passHref" | "legacyBehavior"> {
  children: ReactNode;
  href: string;
  target?: MuiLinkProps["target"];
}

export function LinkWrapper({
  href,
  legacyBehavior,
  passHref,
  ...props
}: Props) {
  const isAbsolute = /^https?:\/\//.test(href);
  const { locale } = useLocale();
  const { href: hrefKeepingRedirectionParams } =
    useHrefKeepingRedirectionParams(href);

  return isAbsolute ? (
    <MuiLink href={href} {...props} />
  ) : (
    <Link
      href={prependLocaleToPath(hrefKeepingRedirectionParams, locale)}
      {...props}
      legacyBehavior={legacyBehavior}
      passHref={passHref}
      shallow
    />
  );
}
